export default class Lights {
  static on() {
    let lights = document.querySelector('.lights');
    if (!lights) {
      return;
    }
    lights.classList.remove('lights--animate');

    setTimeout(() => {
      lights.remove();
    }, 300);
  }

  static off() {
    let node = Lights.createElement();

    node.addEventListener('click', () => {
      this.close();
    });

    document.body.appendChild(node);

    setTimeout(function() {
      node.classList.add('lights--animate');
    }, 1);
  }

  static offWithCloseButton() {
    let node = Lights.createElementWithCloseButton();

    node.addEventListener('click', () => {
      this.close();
    });

    document.body.appendChild(node);

    setTimeout(function() {
      node.classList.add('lights--animate');
    }, 1);
  }

  static createElement() {
    let container = document.createElement('div');
    container.classList.add('lights');

    return container;
  }

  static createElementWithCloseButton() {
    let container = Lights.createElement();

    let closeButton = `
    <div class="lights-close__wrapper">
      <a class="lights-close__button">
        <i class="lights-close__button-icon"></i>
      </a>
    </div>
    `;

    container.innerHTML = closeButton;

    return container;
  }

  /******************
   * Keyboard Event *
   ******************/

  static addEscapeKeyEvent() {
    document.body.addEventListener('keydown', (e) => {
      let lightsElement = document.querySelector('.lights');
      if (!lightsElement) {
        return;
      }
      if(e.key == 'Escape' || e.key == 'Esc') {
        this.close();
      }
    });
  }
}
